import React, { Component } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { message, Modal, Upload } from 'antd';
import { isMobile } from 'react-device-detect';
import { getBase64 } from '@/utils/helpers';

const ACCEPTED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'jpg', 'jpeg', 'png'];
const MAX_FILE_SIZE = 20 * 1024 * 1024;
const { Dragger } = Upload;

export class DocumentFileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileList: this.toFileList(props.value),
            previewVisible: false,
            previewImage: ''
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resetKey !== this.props.resetKey) {
            this.setState({ fileList: this.toFileList(this.props.value) });
        }
    }

    toFileList = (value = []) => (value || []).map((file, index) => ({
        uid: file.id || `existing-${index}`,
        name: file.name,
        status: 'done',
        url: file.data,
        data: file.data
    }));

    getExtension = fileName => String(fileName || '').split('.').pop().toLowerCase();

    validateFile = (file, showMessage = true) => {
        const extension = this.getExtension(file.name);
        if (!ACCEPTED_EXTENSIONS.includes(extension)) {
            if (showMessage) message.error('Chỉ hỗ trợ PDF, Word, Excel, PowerPoint, JPG và PNG.');
            return false;
        }
        if (file.size > MAX_FILE_SIZE) {
            if (showMessage) message.error('Dung lượng mỗi tệp không được vượt quá 20 MB.');
            return false;
        }
        return true;
    };

    beforeUpload = file => {
        file.isInvalidDocumentFile = !this.validateFile(file);
        return false;
    };

    handleChange = async ({ fileList }) => {
        const validList = fileList
            .filter(file => !file.isInvalidDocumentFile && !file.originFileObj?.isInvalidDocumentFile)
            .slice(-10);
        const normalizedList = await Promise.all(validList.map(async file => {
            const data = file.data || file.url || await getBase64(file.originFileObj);
            return { ...file, status: 'done', data };
        }));

        this.setState({ fileList: normalizedList });
        this.props.onChange(normalizedList.map(file => ({ name: file.name, data: file.data })));
    };

    preview = file => {
        const source = file.data || file.url;
        if (/\.(png|jpe?g)$/i.test(file.name) || String(source).startsWith('data:image/')) {
            this.setState({ previewVisible: true, previewImage: source });
            return;
        }
        window.open(source, '_blank', 'noopener,noreferrer');
    };

    download = file => {
        const link = document.createElement('a');
        link.href = file.data || file.url;
        link.download = file.name;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.click();
    };

    render() {
        return (
            <>
                <Dragger
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png"
                    multiple
                    maxCount={10}
                    fileList={this.state.fileList}
                    beforeUpload={this.beforeUpload}
                    onChange={this.handleChange}
                    onPreview={this.preview}
                    onDownload={this.download}
                    showUploadList={{ showPreviewIcon: true, showDownloadIcon: true, showRemoveIcon: true }}
                >
                    <p className="ant-upload-drag-icon" style={{ marginBottom: 0 }}>
                        <InboxOutlined style={{ fontSize: 30 }} />
                    </p>
                    <p className="ant-upload-text" style={{ fontSize: 14 }}>
                        Click hoặc kéo thả file để upload
                    </p>
                </Dragger>
                <div style={{ color: '#888', marginTop: 6 }}>
                    Tối đa 10 tệp, mỗi tệp 20 MB. Hỗ trợ PDF, Office, JPG và PNG.
                </div>
                <Modal
                    visible={this.state.previewVisible}
                    title="Xem trước tệp"
                    footer={null}
                    maskClosable={false}
                    width={isMobile ? '100%' : '70%'}
                    onCancel={() => this.setState({ previewVisible: false, previewImage: '' })}
                >
                    <div style={{ textAlign: 'center' }}>
                        <img alt="Xem trước văn bản" src={this.state.previewImage} style={{ maxWidth: '100%', maxHeight: '70vh' }} />
                    </div>
                </Modal>
            </>
        );
    }
}

DocumentFileUpload.defaultProps = {
    value: [],
    onChange: () => {},
    resetKey: 'new'
};

export default DocumentFileUpload;
